import React from "react";
import { View } from "react-native";
import arrowIcon from "@/assets/arrow-icon.png";
import { TposIcon } from "../Icons/TposIcon";

type ExpandIconProps = {
  isOpen: boolean;
};

const ExpandIcon = ({ isOpen }: ExpandIconProps): JSX.Element => (
  <View style={{ transform: [{ rotate: isOpen ? "0deg" : "180deg" }] }}>
    <TposIcon icon={arrowIcon} size={25} />
  </View>
);

export default ExpandIcon;
